export default __webpack_public_path__ + "static/media/punch-chowder-logo.8dacd054.svg";